/**
 * Created by Abner Sui on 07/05/2019.
 * Description:
 *
 * ------ maintenance history ------
 */
import { Component, OnInit } from '@angular/core';
import { AppState } from '../../redux';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { SystemConfig } from '../../models/global-setting';
import { SettingScreenService } from '../../services/setting-screen.service';
import { ManageRelTreeDialogActions } from './settings.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { SystemUser } from '../../tamalelibs/models/user.model';

@Component({
    selector: 'advanced-setting',
    templateUrl: './advanced-setting.component.html',
    styleUrls: ['./advanced-setting.component.scss']
})
export class AdvancedSettingComponent implements OnInit {

    accessTamaleDirectly: boolean;
    isAdminUser = false;
    private _currentUser: SystemUser;

    constructor(
        private _store: Store<AppState>,
        private _settingScreenService: SettingScreenService,
        private _storeQuerier: StoreQuerierService,
    ) { }

    ngOnInit() {
        this._currentUser = this._storeQuerier.getCurrentUser();
        this.isAdminUser = this._currentUser.credential.admin;
        this._store.pipe(
            select('systemConfig'),
            take(1),
        ).subscribe((systemConfig: SystemConfig) => {
            this.accessTamaleDirectly = systemConfig.accessTamaleDirectly;
        });
    }

    onBtnManageRelationship() {
        this._settingScreenService.manageRelDialogActionSubject$.next({
            type: ManageRelTreeDialogActions.OPEN,
        });
    }

}
